import type { SVGProps } from 'react';

interface TwitterIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const TwitterIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & TwitterIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 25 25"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <rect fill="#4FA9FF" height={25} rx={12.5} width={25} />
    <g clipPath="url(#twitter_svg__a)">
      <path
        d="M17.974 9.748v.364q0 1.372-.504 2.716a8 8 0 0 1-1.484 2.478 7.3 7.3 0 0 1-2.422 1.82q-1.512.7-3.304.7a7.7 7.7 0 0 1-2.226-.322 8 8 0 0 1-1.96-.882q.225.028.658.028.91 0 1.771-.3a5.9 5.9 0 0 0 1.59-.848 2.65 2.65 0 0 1-1.555-.56 2.4 2.4 0 0 1-.966-1.33q.336.056.504.056.252 0 .728-.112a2.6 2.6 0 0 1-.868-.329 2.7 2.7 0 0 1-.707-.616 2.72 2.72 0 0 1-.609-1.715v-.028q.63.336 1.232.336a2.64 2.64 0 0 1-.896-.98 2.8 2.8 0 0 1-.308-1.26q0-.728.35-1.4.995 1.232 2.492 2.03a7.9 7.9 0 0 0 3.122.812 2 2 0 0 1-.084-.602q0-.517.224-1.036.196-.49.574-.896.35-.378.875-.588a2.76 2.76 0 0 1 2.142.014q.525.224.89.644a6.6 6.6 0 0 0 1.721-.644q-.35.995-1.204 1.47a5.4 5.4 0 0 0 1.554-.406q-.266.406-.455.616-.19.21-.58.532z"
        fill="#F8F8F8"
      />
    </g>
    <defs>
      <clipPath id="twitter_svg__a">
        <path d="M5.5 20.5h14v-14h-14z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
